<template>
  <div>
    <v-card class="mb-3 px-5 pa-7 rounded-xl" :elevation="0">
      <div
        class="text-left call-to-action-left-btn"
        @click="toggleCallToActionModal"
      >
        <v-icon class="call-to-action-left-icon">mdi-chevron-left</v-icon>
        Call-to-action
      </div>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="saveCallToActionDetails"
        class="mt-3"
        lazy-validation
      >
        <div class="input-group">
          <label for="">Button link (URL)</label>
          <v-text-field
            class="input-field"
            v-model="form.cta_button_url"
            type="url"
            :rules="urlRules"
            required
            solo
            dense
            flat
            outlined
            rounded
          ></v-text-field>
        </div>
        <div class="input-group">
          <label for="">Button text</label>
          <v-text-field
            class="input-field"
            v-model="form.cta_button_text"
            type="text"
            :rules="requiredRules"
            required
            solo
            dense
            flat
            outlined
            rounded
          ></v-text-field>
        </div>
        <div class="input-group">
          <label for="">Button color</label>
          <v-text-field
            class="input-field"
            v-model="form.cta_button_color"
            type="color"
            solo
            dense
            flat
            outlined
            rounded
          ></v-text-field>
        </div>
        <div class="input-group">
          <label for="">Text color</label>
          <v-text-field
            class="input-field"
            v-model="form.cta_text_color"
            type="color"
            solo
            dense
            flat
            outlined
            rounded
          ></v-text-field>
        </div>
        <div class="input-group">
          <label for="">Button corner style</label>
          <v-select
            :items="buttonCornerStyleList"
            item-text="name"
            item-value="key"
            v-model="form.cta_button_style"
            class="input-field"
            required
            solo
            dense
            flat
            outlined
            rounded
          >
            <template v-slot:item="{ item }">
              <div class="text-center">{{ item.name }}</div>
            </template>
          </v-select>
        </div>
        <!-- <div class="input-group">
          <label for="">Logo</label>
          <div class="rounded-xl dotted-border">
            <cta-drag-and-drop
              user_id="null"
              logo_url="null"
            ></cta-drag-and-drop>
          </div>
        </div> -->
        <template>
          <v-btn
            block
            depressed
            color="primary"
            class="rounded-xl text-capitalize mt-8"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            Save</v-btn
          >
        </template>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ResponseHelper from "../../utils/ResponseHelper";

export default {
  name: "CallToActionSettings",
  props: {
    recordDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      toast: new ResponseHelper(),
      form: {
        cta_button_url: "",
        cta_button_text: "",
        cta_button_color: "#000000",
        cta_text_color: "#ffffff",
        cta_button_style: "rounded",
      },
      // Validation rules
      urlRules: [
        (v) => !!v || "URL is required",
        (v) => {
          const pattern =
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
          return pattern.test(v) || "Please enter a valid URL";
        },
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      buttonCornerStyleList: [
        { key: "rounded", name: "Rounded" },
        { key: "squared", name: "Squared" },
        { key: "srounded", name: "Slightly Rounded" },
      ],
    };
  },
  methods: {
    ...mapActions({
      video_settings: "recordings/video_settings",
      update_video_settings: "recordings/update_video_settings",
    }),
    async getVideoSettings() {
      try {
        const response = await this.video_settings(this.recordDetails.id);
        // Set values from API response, fallback to defaults if not provided
        this.form = {
          cta_button_url: response?.data?.cta_button_url ?? "",
          cta_button_text: response?.data?.cta_button_text ?? "",
          cta_button_color: response?.data?.cta_button_color || "#000000",
          cta_text_color: response?.data?.cta_text_color || "#ffffff",
          cta_button_style: response?.data?.cta_button_style ?? "rounded",
        };
      } catch (e) {
        console.log(e);
        // Set default values in case of API error
        this.form = {
          cta_button_url: "",
          cta_button_text: "",
          cta_button_color: "#000000",
          cta_text_color: "#ffffff",
          cta_button_style: "rounded",
        };
      }
    },
    async saveCallToActionDetails() {
      // Validate form before proceeding
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.form.recording_id = this.recordDetails.id;
      this.form.user_id = this.recordDetails.user_id;

      try {
        const response = await this.update_video_settings(this.form);
        await this.getVideoSettings();

        // Update the store with new video settings
        const updatedRecordDetails = {
          ...this.recordDetails,
          video_settings: {
            ...this.recordDetails.video_settings,
            ...this.form,
          },
        };
        this.$store.commit("recordings/SHOW_DETAILS", updatedRecordDetails);

        this.$response.sendSuccess(response);
        this.$refs.form.resetValidation();
      } catch (e) {
        this.$response.sendError(e);
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    toggleCallToActionModal() {
      this.$emit("toggle-card");
    },
  },
  mounted() {
    this.getVideoSettings();
  },
};
</script>

<style scoped>
/** Call to action styles */
.call-to-action-left-btn {
  font-weight: 600;
  cursor: pointer;
}
.call-to-action-left-btn:hover {
  color: blue !important;
}
.call-to-action-left-icon {
  margin-top: -4px;
  margin-right: -4px;
}

/** Input style */
.input-group {
  text-align: left;
  margin-bottom: 12px;
}
.input-group > label {
  font-size: 14px;
}
.input-group > .input-field {
  height: 42px !important;
}
</style>
